import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/geren.png'
import _imports_1 from '@/assets/icon/qiye.png'
import _imports_2 from '@/assets/icon/weirenzheng.png'
import _imports_3 from '@/assets/icon/vip1.png'
import _imports_4 from '@/assets/icon/vip2.png'
import _imports_5 from '@/assets/icon/vip3.png'
import _imports_6 from '@/assets/icon/vip4.png'
import _imports_7 from '@/assets/icon/vip5.png'
import _imports_8 from '@/assets/icon/vip6.png'


const _withScopeId = n => (_pushScopeId("data-v-04a18ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "clb" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "会员有效期至:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_12 = { class: "viprecord" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开通记录", -1))
const _hoisted_15 = { class: "record" }
const _hoisted_16 = { class: "box1" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_20 = {
  key: 2,
  src: _imports_5,
  alt: ""
}
const _hoisted_21 = {
  key: 3,
  src: _imports_6,
  alt: ""
}
const _hoisted_22 = {
  key: 4,
  src: _imports_7,
  alt: ""
}
const _hoisted_23 = {
  key: 5,
  src: _imports_8,
  alt: ""
}
const _hoisted_24 = {
  key: 6,
  style: {"color":"#4b72ca","backgroundcolor":"linear-gradient(\r\n                    267.26deg,\r\n                    #578afa -3.12%,\r\n                    #84a9fa 52.28%\r\n                  )"}
}
const _hoisted_25 = {
  key: 7,
  style: {"color":"#5d54c7","backgroundcolor":"linear-gradient(\r\n                    265.4deg,\r\n                    #948bf8 -0.06%,\r\n                    #a59dfa 52.65%\r\n                  )"}
}
const _hoisted_26 = {
  key: 8,
  style: {"color":"#ac2925","backgroundcolor":"linear-gradient(\r\n                    87.41deg,\r\n                    #ff7a73 49.97%,\r\n                    #f95c58 100.34%\r\n                  )"}
}
const _hoisted_27 = {
  key: 9,
  style: {"color":"#fbb114"}
}
const _hoisted_28 = {
  key: 10,
  style: {"color":"#7eb2be"}
}
const _hoisted_29 = {
  key: 11,
  style: {"color":"#79aaf2"}
}
const _hoisted_30 = { class: "right" }
const _hoisted_31 = { class: "time" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "开通时间", -1))
const _hoisted_33 = { class: "balance" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_ctx.userinfot.username), 1),
        (
          _ctx.getInformation.data.company_id == null &&
          _ctx.getInformation.data.identification == 3
        )
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.getInformation.data.company_id != null)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (
          _ctx.getInformation.data.company_id == null &&
          _ctx.getInformation.data.identification != 3
        )
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        _hoisted_6,
        (_ctx.vipinfo.userimgurl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 3,
              src: _ctx.vipinfo.userimgurl,
              alt: ""
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          class: "vip-title",
          style: _normalizeStyle({ color: _ctx.vipinfo.usercolor })
        }, _toDisplayString(_ctx.userinfot.vipInfo.vipTitle), 5)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.getTime(0)), 1)
        ]),
        _createElementVNode("div", {
          class: "right",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisible()))
        }, "会员开通记录 >>")
      ])
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "580px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("i", {
              class: "iconfont",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viprecord.data.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (item.order_type == 3 && item.vip_id == 16)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                    : _createCommentVNode("", true),
                  (item.order_type == 3 && item.vip_id == 17)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                    : _createCommentVNode("", true),
                  (item.order_type == 3 && item.vip_id == 18)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 16)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 17)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 18)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 16)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, " 月度会员 "))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 17)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, " 季度会员 "))
                    : _createCommentVNode("", true),
                  (item.order_type == 2 && item.vip_id == 18)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 年度会员 "))
                    : _createCommentVNode("", true),
                  (item.order_type == 3 && item.vip_id == 16)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, " 黄金VIP会员 "))
                    : _createCommentVNode("", true),
                  (item.order_type == 3 && item.vip_id == 17)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, " 白金VIP会员 "))
                    : _createCommentVNode("", true),
                  (item.order_type == 3 && item.vip_id == 18)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, " 钻石VIP会员 "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("p", null, _toDisplayString(item.ctime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    (item.order_type == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, "齿轮币金额"))
                      : _createCommentVNode("", true),
                    (item.order_type == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, "有效期"))
                      : _createCommentVNode("", true),
                    (item.order_type == 2)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.getTime(index)), 1))
                      : _createCommentVNode("", true),
                    (item.order_type == 3 && item.vip_id == 16)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, "6500"))
                      : _createCommentVNode("", true),
                    (item.order_type == 3 && item.vip_id == 17)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_38, "18000"))
                      : _createCommentVNode("", true),
                    (item.order_type == 3 && item.vip_id == 18)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_39, "36000"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}